import { ArticleAuthor } from 'stores/ArticleStoreAdapter';

/** 著者一覧を「、」区切りの表示名文字列に整形する（ArticleNav の関連記事カード用）。 */
export const formatAuthors = (authors: ArticleAuthor[]): string =>
  authors.map((a) => a.userName).join('、');
